import { render, staticRenderFns } from "./aboutContact.vue?vue&type=template&id=17caef3e&"
import script from "./aboutContact.vue?vue&type=script&lang=js&"
export * from "./aboutContact.vue?vue&type=script&lang=js&"
import style0 from "./aboutContact.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports